import { Component, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-representatives',
  templateUrl: './representatives.component.html',
})
export class RepresentativesComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
